import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles, Dumbbell, Utensils, Bed } from 'lucide-react';
import { PageContainer } from '../../components/layout/PageContainer/PageContainer';
import { OfferCard } from '../../components/features/OfferCard/OfferCard';
import { offerCategories, hotDeals, heroImages } from '../../data/mockData';

const categoryIcons: Record<string, React.ReactNode> = {
  Sparkles: <Sparkles className="w-10 h-10" />,
  Dumbbell: <Dumbbell className="w-10 h-10" />,
  Utensils: <Utensils className="w-10 h-10" />,
  Bed: <Bed className="w-10 h-10" />,
};

export const OffersPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer
      heroImage={heroImages.offers}
      heroHeight="small"
      heroTitle={t('offers.title')}
      heroSubtitle={t('offers.subtitle')}
      overlayOpacity={0.45}
    >
      {/* Category Section */}
      <div className="mb-10">
        <h2 className="font-display text-2xl text-[#333333] mb-6">Top offers for you</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {offerCategories.map((category) => (
            <OfferCard
              key={category.id}
              variant="category"
              category={{
                ...category,
                icon: categoryIcons[category.icon] || <Sparkles className="w-10 h-10" />,
              }}
              onClick={() => {}}
            />
          ))}
        </div>
      </div>

      {/* Hot Deals Section */}
      <div>
        <h2 className="font-display text-2xl text-[#333333] mb-6">Hot Deals for you</h2>
        <div className="flex gap-4 overflow-x-auto pb-4">
          {hotDeals.map((deal) => (
            <OfferCard
              key={deal.id}
              variant="deal"
              deal={deal}
              onClick={() => {}}
            />
          ))}
        </div>
      </div>
    </PageContainer>
  );
};

export default OffersPage;
